<script>
  import Menu from "../components/Menu.svelte";
  import Breadcrumbs from "../components/Breadcrumbs.svelte";
  import Footer from "../components/Footer.svelte";
  import ArticleListRevisorItem from "../components/ArticleListRevisorItem.svelte";

  import { dictionary } from "../utils/stores.js";
  import { getToken, redirectIfNotToken } from "../utils/token.js";
  import { post } from "../utils/api.js";

  import { onMount } from "svelte";

  redirectIfNotToken("/login");

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  const pageName = "articulos";
  let filtro = "todos";

  let articulos = [];
  let estadosArticulos = [];

  onMount(async () => {
    listarArticulos();
  });

  let listarArticulos = async () => {
    articulos = await post(
      "MisArticulosComoRevisor",
      {
        token: getToken()
      },
      "json"
    );
    articulos.sort(function(a, b) {
      return b.id_articulo - a.id_articulo;
    });
    estadosArticulos = articulos.map(item => {
      let estado = "pendientesAceptacion";
      if (item.miDecision !== "") {
        estado = "pendientesRevision";
        if (item.revisadoDocumento2 !== "") {
          estado = "revisados";
        } else {
          if (item.revisadoDocumento1 !== "" && item.numVersion === 1) {
            estado = "revisados";
          }
        }
      }
      return estado;
    });
  };

  let openArticle = id => {
    location.href = "/articulo/" + id + "/";
  };
</script>

<style>
  div.filtros {
    margin-top: 40px;
  }

  div.filtros span {
    margin-right: 10px;
  }

  div.articulos {
    margin-top: 40px;
    margin-bottom: 20px;
    width: 100%;
  }
</style>

<div class="ie-panel">
  <a href="http://windows.microsoft.com/en-US/internet-explorer/">
    <img
      src="images/ie8-panel/warning_bar_0000_us.jpg"
      height="42"
      width="820"
      alt="You are using an outdated browser. For a faster, safer browsing
      experience, upgrade for free today." />
  </a>
</div>
<div class="preloader" id="loading">
  <div class="preloader-body">
    <div id="loading-center-object">
      <div class="object" id="object_four" />
      <div class="object" id="object_three" />
      <div class="object" id="object_two" />
      <div class="object" id="object_one" />
    </div>
  </div>
</div>
<div class="page">

  <!-- Menu -->

  <Menu {pageName} />

  <!-- Breadcrumbs -->

  <Breadcrumbs pageName={dict[pageName]} />

  <!-- Body -->

  <section class="section">
    <div class="container">
      <h3 class="titulo">{dict['misArticulosRevisor']}</h3>
      <div class="filtros">
        <span>{dict['filtrar']}:</span>
        <select bind:value={filtro}>
          <option value="todos">{dict['todos']}</option>
          <option value="pendientesAceptacion">
            {dict['pendientesAceptacion']}
          </option>
          <option value="pendientesRevision">
            {dict['pendientesRevision']}
          </option>
          <option value="revisados">{dict['revisados']}</option>
        </select>
      </div>
      <div class="articulos">
        {#each articulos as articulo, i}
          {#if filtro === 'todos' || filtro === estadosArticulos[i]}
            <ArticleListRevisorItem
              {articulo}
              onClickArticle={() => openArticle(articulo.id_articulo)} />
          {/if}
        {/each}
      </div>
    </div>
  </section>
  <Footer />
</div>
<div class="snackbars" id="form-output-global" />
